import React from "react";
import { Helmet } from "react-helmet-async";

const normalizeCanonical = (url) => {
  if (!url) {
    return undefined;
  }
  if (url === "https://www.nimantrana.co.in/") {
    return url;
  }
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

const SeoMeta = ({
  title,
  description,
  canonical,
  keywords,
  robots = "index, follow",
  image,
  structuredData
}) => {
  const safeCanonical = normalizeCanonical(canonical);
  const ogDescription = description || undefined;
  const ogTitle = title || undefined;

  return (
    <Helmet>
      {ogTitle && <title>{ogTitle}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {robots && <meta name="robots" content={robots} />}
      {safeCanonical && <link rel="canonical" href={safeCanonical} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {safeCanonical && <meta property="og:url" content={safeCanonical} />}
      <meta property="og:site_name" content="Nimantrana Hospitality" />
      {image && <meta property="og:image" content={image} />}
      {image && (
        <meta
          property="og:image:alt"
          content={description || title || "Nimantrana hospitality visuals"}
        />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      {ogTitle && <meta name="twitter:title" content={ogTitle} />}
      {ogDescription && <meta name="twitter:description" content={ogDescription} />}
      {image && <meta name="twitter:image" content={image} />}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SeoMeta;
